<script>
  export let row = {};
</script>

<span class:negative={row.diff < 0}>{row.diff}</span>

<style lang="scss">
  .negative {
    color: var(--color-red-400);
  }
</style>
